module.exports = __webpack_public_path__ + "img/402.5922b66f.png";